import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { createRandomSeed } from '../../utils/functions';

const Cypress: React.FC<IconProps> = ({ size, style }) => {
  const rndSeed = createRandomSeed();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" data-testid="cypress-icon" viewBox="0 0 24 24" style={style}>
      <g fill="#fff" clipPath={`url(#a-${rndSeed})`}>
        <path d="M.427 15.18C.144 14.148 0 13.078 0 12 0 7.08 3.09 2.58 7.691.807l.603 1.56c-3.96 1.528-6.62 5.4-6.62 9.635 0 .929.124 1.849.367 2.735l-1.614.443Z" />
        <path d="M7.61.844C8.607.454 9.657.2 10.729.087c4.894-.514 9.692 2.089 11.937 6.479l-1.49.763c-1.933-3.779-6.06-6.02-10.272-5.577-.924.098-1.826.316-2.683.65L7.61.845Z" />
        <path d="M17.492 20.726a10.333 10.333 0 0 0 4.75-9.646c-.12-1.37-.5-2.678-1.128-3.885l1.484-.774a11.997 11.997 0 0 1 1.312 4.513 12 12 0 0 1-5.518 11.204l-.9-1.412ZM8.439 9.525c.97 0 1.762.518 2.168 1.42l.033.071 1.63-.553-.034-.084c-.632-1.538-2.087-2.494-3.797-2.494-1.203 0-2.18.386-2.988 1.177-.802.786-1.209 1.776-1.209 2.941 0 1.155.407 2.14 1.21 2.926.807.791 1.784 1.177 2.987 1.177 1.71 0 3.165-.956 3.797-2.493l.034-.083-1.633-.555-.03.073c-.365.888-1.175 1.418-2.168 1.418-.677 0-1.248-.236-1.7-.701-.458-.472-.69-1.064-.69-1.76 0-.702.227-1.283.69-1.776.451-.468 1.023-.704 1.7-.704Z" />
        <path d="m18.654 8.037-2.325 5.88-2.339-5.88h-1.914l3.281 8.026-2.334 5.662 1.673.332 5.766-14.02h-1.808Z" />
        <path d="m13.322 20.995-.408.986a.543.543 0 0 1-.475.337 11.02 11.02 0 0 1-.416.01c-4.799-.003-9.045-3.386-10.097-8.048l-1.633.369a12.04 12.04 0 0 0 4.172 6.684A12.075 12.075 0 0 0 12.005 24h.024c.16 0 .32-.004.48-.01a2.222 2.222 0 0 0 1.955-1.372l.532-1.29-1.674-.333Z" />
      </g>
      <defs>
        <clipPath id={`a-${rndSeed}`}>
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Cypress;
